import React from 'react';
import { OptimizelyFeature, OptimizelyProvider } from '@optimizely/react-sdk';
import ErrorBoundary from './ErrorBoundary';
import { MaintenanceMode } from './maintenance-mode/maintenanceMode';
import DeprecatedDomain from './deprecatedDomain/deprecatedDomain';
import { optimizely } from './utils/optimizely/config';

const deprecatedMvcDomain = 'mvc.gumgum.com';
const isWindowLocationOnDeprecatedDomain =
    !process.env.REACT_APP_DEV &&
    window.location.origin.includes(deprecatedMvcDomain);

interface OptimizelyWrapperProps {
    children: React.ReactNode;
}

const OptimizelyWrapper = ({ children }: OptimizelyWrapperProps) => {
    return (
        <OptimizelyProvider optimizely={optimizely}>
            {isWindowLocationOnDeprecatedDomain && <DeprecatedDomain />}
            {!isWindowLocationOnDeprecatedDomain && (
                <OptimizelyFeature feature="db_maintenance">
                    {isEnabled =>
                        isEnabled ? (
                            <MaintenanceMode />
                        ) : (
                            <ErrorBoundary>{children}</ErrorBoundary>
                        )
                    }
                </OptimizelyFeature>
            )}
        </OptimizelyProvider>
    );
};

export default OptimizelyWrapper;
